
import type { SlaLevel, TicketSla } from '../model/types';

export function formatWorkMinutes(minutes: number): string {
  const abs = Math.abs(Math.round(minutes));
  if (abs < 60) return `${abs} мин`;
  if (abs < 60 * 8) {
    const hours = Math.floor(abs / 60);
    const rest = abs % 60;
    return rest === 0 ? `${hours} ч` : `${hours} ч ${rest} мин`;
  }
  const days = Math.round((abs / (60 * 8)) * 10) / 10;
  return `${days} дн`;
}

export function slaChipLabel(sla: TicketSla): string {
  if (sla.level === 'breached') {
    return sla.remainingMinutes < 0
      ? `Просрочено на ${formatWorkMinutes(sla.remainingMinutes)}`
      : 'Просрочено';
  }
  return formatWorkMinutes(sla.remainingMinutes);
}

export function slaChipTitle(sla: TicketSla): string {
  const what = sla.kind === 'reaction' ? 'Срок первого ответа' : 'Срок решения';
  const scale = 'считается в рабочих минутах по календарю группы';
  if (sla.paused) return `${what} — счётчик остановлен: заявка на паузе (${scale})`;
  if (sla.level === 'breached') return `${what} нарушен (${scale})`;
  return `${what}: осталось ${formatWorkMinutes(sla.remainingMinutes)} (${scale})`;
}

export function slaProgress(sla: TicketSla): number {
  if (sla.targetMinutes <= 0) return 0;
  return Math.min(1, Math.max(0, sla.spentMinutes / sla.targetMinutes));
}

export function slaTone(sla: TicketSla): SlaLevel | 'paused' {
  return sla.paused ? 'paused' : sla.level;
}

export function slaShortLabel(sla: TicketSla): string {
  if (sla.remainingMinutes < 0) return `−${formatWorkMinutes(sla.remainingMinutes)}`;
  return formatWorkMinutes(sla.remainingMinutes);
}
